import { UseFormReturn } from 'react-hook-form';

import { Form } from '@/shared/components/ui/form/form';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { TLoginInputSchema } from '@/shared/features/auth/components/login/login.types';
import { loginInputSchema } from '@/shared/features/auth/components/login/login.validation';
import { LoginWithCredentialsForm } from '@/shared/features/auth/components/login-with-credentials/login-with-credentials-form';
import { useLoginNextStep } from '@/shared/features/auth/hooks/use-login-next-step/use-login-next-step';
import { fetchCurrentUser, login } from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const LoginWithCredentials = () => {
  const dispatch = useAppDispatch();
  const handleLoginNexStep = useLoginNextStep();

  const handleSubmit = async (
    data: TSubmittedData<TLoginInputSchema>,
    methods: UseFormReturn<TLoginInputSchema>,
  ) => {
    const { setError } = methods;
    const username = data.data.username;

    try {
      const { isSignedIn, nextStep } = await dispatch(
        login(data.data),
      ).unwrap();

      if (isSignedIn) {
        // AuthRoot sends a signed-in user to '/'; awaiting here means its loader
        // runs once, with the user already in the store.
        await dispatch(fetchCurrentUser());
        return;
      }
      const signInStep = nextStep?.signInStep;
      handleLoginNexStep({ signInStep, username });
    } catch {
      setError('password', {
        type: 'manual',
        message: 'incorrect_username_or_password',
      });
      setError('username', {
        type: 'manual',
        message: 'no_message',
      });
    }
  };

  return (
    <Form<TLoginInputSchema> onSubmit={handleSubmit} schema={loginInputSchema}>
      {() => <LoginWithCredentialsForm />}
    </Form>
  );
};
